import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetBackofficeSupportActivitySchema,
  GetDeflectionActivityResponseDataSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeSupportActivitySchema>
type Response = DataResponse<z.infer<typeof GetDeflectionActivityResponseDataSchema>>

const getBackofficeSupportDeflectionActivityQueryKey = (query: Query) => [
  "backofficeSupportDeflectionActivity",
  query,
]

type Props = { query: Query; enabled?: boolean }

export const getBackofficeSupportDeflectionActivityQuery = ({ query, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getBackofficeSupportDeflectionActivityQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/support/deflection-activity", {
        params: query,
      })
      return data.data
    },
    enabled,
  })
}
